<template>
  <main
    class="blank-container"
    :class="{
      'has-background': $route.meta.is_has_bg,
      'blur-background': shouldBlurBackground && $route.meta.is_has_bg
    }"
  >
    <slot />
  </main>
</template>

<script>
export default {
  name: 'BlankLayout',
  components: {},
  computed: {
    shouldBlurBackground () {
      return process.env.VUE_APP_ENV !== 'production';
    },
  },
};
</script>
<style scoped>
</style>
